import React from 'react'
interface StatusNewIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusNewIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusNewIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Star burst for "new" */}
      <path d="M12 7v10" />
      <path d="M7 12h10" />
      <path d="M8.5 8.5l5 5" />
      <path d="M15.5 8.5l-5 5" />
    </svg>
  )
}
